import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/monitor/play-icon.png';
import _imports_1 from '@/assets/img/monitor/focus-icon.png';
import _imports_2 from '@/assets/img/monitor/nfocus-icon.png';
import _imports_3 from '@/assets/img/monitor/full-icon.png';
import _imports_4 from '@/assets/img/equipmentLive/nothing.png';
import _imports_5 from '@/assets/img/monitor/close-icon.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5c052629"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "monitor-live"
};
var _hoisted_2 = {
  class: "siderbar"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "num"
};
var _hoisted_5 = {
  class: "text"
};
var _hoisted_6 = {
  class: "content",
  id: "contentWrap"
};
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  key: 0,
  class: "img-box"
};
var _hoisted_9 = ["src", "onClick"];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "img-fallback"
  }, "监控图片加载失败", -1);
});
var _hoisted_11 = ["onClick"];
var _hoisted_12 = ["id", "onClick"];
var _hoisted_13 = ["onClick"];
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  class: "flex align-center justify-between monitor-cont"
};
var _hoisted_16 = ["onClick"];
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "full-icon",
    src: _imports_3
  }, null, -1);
});
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "full-text"
  }, "全屏", -1);
});
var _hoisted_19 = [_hoisted_17, _hoisted_18];
var _hoisted_20 = {
  key: 1,
  class: "nothing"
};
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4
  }, null, -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1);
});
var _hoisted_23 = [_hoisted_21, _hoisted_22];
var _hoisted_24 = {
  key: 0,
  id: "full-video-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siderbar, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: item.cate_name,
      class: _normalizeClass(["flex flex-column align-center justify-center siderbar-item", {
        active: _ctx.curSiderbarIndex === index
      }]),
      onClick: function onClick($event) {
        return _ctx.siderbarClick(index, item.cate_name);
      }
    }, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.monitor_count), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(item.cate_name), 1)], 10, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_ctx.monitorList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monitorList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "monitor-item"
    }, [!item.isPlayer ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
      class: "monitor-img",
      src: item.pic_url,
      alt: "监控图片",
      onClick: function onClick($event) {
        return _ctx.handlePlay(item, index);
      },
      onerror: "handleImgError(this)"
    }, null, 8, _hoisted_9), _hoisted_10])) : _createCommentVNode("", true), !item.isPlayer ? (_openBlock(), _createElementBlock("img", {
      key: 1,
      class: "play-icon",
      src: _imports_0,
      onClick: function onClick($event) {
        return _ctx.handlePlay(item, index);
      }
    }, null, 8, _hoisted_11)) : _createCommentVNode("", true), item.isPlayer ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      id: "video-container-".concat(item.id),
      class: "video-container",
      onClick: function onClick($event) {
        return _ctx.handlePause(item, index);
      }
    }, null, 8, _hoisted_12)) : _createCommentVNode("", true), item.focus == '1' ? (_openBlock(), _createElementBlock("img", {
      key: 3,
      class: "fcous-icon",
      src: _imports_1,
      onClick: function onClick($event) {
        return _ctx.handleFocus(item, index);
      }
    }, null, 8, _hoisted_13)) : _createCommentVNode("", true), item.focus == '0' ? (_openBlock(), _createElementBlock("img", {
      key: 4,
      class: "fcous-icon",
      src: _imports_2,
      onClick: function onClick($event) {
        return _ctx.handleFocus(item, index);
      }
    }, null, 8, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, _toDisplayString(item.title), 1), _createElementVNode("div", {
      class: "flex align-center",
      onClick: function onClick($event) {
        return _ctx.handleFullScreen(item);
      }
    }, _hoisted_19, 8, _hoisted_16)])]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))])]), _ctx.isFullePlayer ? (_openBlock(), _createElementBlock("div", _hoisted_24)) : _createCommentVNode("", true), _ctx.isFullePlayer ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "close-icon",
    src: _imports_5,
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.closeFullScreen && _ctx.closeFullScreen.apply(_ctx, arguments);
    })
  })) : _createCommentVNode("", true)]);
}